import { Card } from '@components/atoms/Card';
import { Badge } from '@components/atoms/Badge';
import { Avatar } from '@components/atoms/Avatar';
import { ButtonLink } from '@components/atoms/ButtonLink';
import { Progress } from '@components/atoms/Progress';

export const SmallComponents = () => {
  return (
    <Card>
      <div className="flex gap-2">
        <div className="flex flex-col gap-2">
          <Badge size="sm">Badge</Badge>
          <Badge size="md">Badge</Badge>
          <Badge size="lg">Badge</Badge>
        </div>
        <div className="flex gap-2">
          <Avatar size="lg" text="Dario" />
          <Avatar
            size="md"
            text="C"
            src="https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=761&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          />
          <Avatar
            size="sm"
            text="A"
            src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          />
        </div>
        <div className="flex gap-2">
          <ButtonLink external href="https://www.google.com">
            ButtonLink
          </ButtonLink>
        </div>
        <div className="flex flex-col gap-3 min-w-48">
          <div>
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Progress Bars
            </h4>
            <Progress value={25} size="sm" showPercentage />
          </div>
          <Progress value={60} size="md" variant="success" showPercentage />
          <Progress value={80} size="lg" variant="warning" label="Loading..." />
          <Progress value={100} variant="primary" showPercentage />
        </div>
      </div>
    </Card>
  );
};
